import type { Messages } from '../catalogue.en'

export const estimates: Partial<Messages> = {
  'estimate.send.routingPreferences': 'Канал доставки определяется настройками коммуникации пациента.',
  'estimate.status.draft': 'Черновик',
  'estimate.status.issued': 'Выпущена',
  'estimate.source.clinic': 'Услуга клиники',
  'estimate.source.external': 'Внешний расход',
  'estimate.template.clinicTreatment': 'Лечение в клинике',
  'estimate.template.externalMedical': 'Внешние медицинские услуги',
  'estimate.template.documentsAndLegal': 'Документы и юридические услуги',
  'estimate.template.travelAndTransfer': 'Проезд и трансферы',
  'estimate.template.accommodation': 'Проживание',
  'estimate.template.dailyLiving': 'Повседневные расходы',
  'estimate.template.other': 'Прочее',
  'estimate.unit.item': 'шт.',
  'estimate.unit.service': 'услуга',
  'estimate.unit.day': 'день',
  'estimate.unit.night': 'ночь',
  'estimate.unit.trip': 'поездка',
  'estimate.unit.hour': 'час',
  'estimate.unit.week': 'неделя',
  'estimate.unit.person': 'человек',
  'estimate.unit.package': 'пакет',
  'estimate.expiry.24h': '24 часа',
  'estimate.expiry.7d': '7 дней',
  'estimate.expiry.30d': '30 дней',
  'estimate.drift.unavailable': 'Источник больше недоступен; строка сохраняет свой снимок.',
  'estimate.drift.price': 'Цена в справочнике изменилась с момента добавления строки.',
  'estimate.drift.revision': 'В справочнике есть более новая редакция этого источника.',
  'estimate.error.issuedAlready': 'Смета уже выпущена, изменить её нельзя.',
  'estimate.error.sourceUnavailable': 'Один из источников больше недоступен.',
  'estimate.error.limit': 'Смета превышает ограничение: 20 разделов, 200 строк, количество 1–9999.',
  'estimate.error.issueInvalid': 'Смету в текущем виде выпустить нельзя.',
  'estimate.error.idempotency': 'Этот запрос уже был отправлен с другим содержимым.',
  'estimate.error.forbidden': 'Вашей учётной записи это не разрешено.',
  'estimate.error.notFound': 'Смета не найдена.',
  'estimate.error.invalid': 'Сервер отклонил смету в отправленном виде.',
  'estimate.error.conflict': 'Смета изменилась на сервере.',
  'estimate.error.failed': 'Не удалось сохранить смету.',

  'estimate.list.title': 'Сметы',
  'estimate.list.column.title': 'Смета',
  'estimate.list.column.locale': 'Язык',
  'estimate.list.column.validThrough': 'Действует до',
  'estimate.list.column.total': 'Итого',
  'estimate.list.column.when': 'Выпущена / обновлена',
  'estimate.list.column.actions': 'Действия',
  'estimate.list.noNumber': 'Номера пока нет',
  'estimate.list.pendingDraft': 'Черновик, редакция {revision}',
  'estimate.list.openPendingDraft': 'Открыть черновик редакции {revision} сметы {name}',
  'estimate.list.issuedAt': 'Выпущена {time}',
  'estimate.list.updatedAt': 'Обновлена {time}',
  'estimate.list.openDraft': 'Открыть черновик {name}',
  'estimate.list.openIssued': 'Открыть смету {name}',
  'estimate.list.create': 'Новая смета',
  'estimate.list.empty': 'Смет пока нет',
  'estimate.list.emptyDetail': 'Для этого пациента ещё ничего не рассчитывалось.',
  'estimate.list.emptyDetailWrite': 'Создайте первую смету, чтобы спланировать стоимость лечения.',
  'estimate.list.noMatches': 'Нет подходящих смет',
  'estimate.list.noMatchesDetail': 'Ослабьте фильтры, чтобы увидеть больше смет.',
  'estimate.list.loading': 'Загрузка смет…',
  'estimate.list.loadFailed': 'Не удалось загрузить сметы.',
  'estimate.list.forbidden': 'Сметы недоступны вашей учётной записи',
  'estimate.list.forbiddenDetail': 'Для чтения смет лечения нужно право finance.estimates.read.',

  'estimate.create.title': 'Новая смета',
  'estimate.create.description': 'Сначала шапка; строки выбираются в редакторе.',
  'estimate.create.defaultTitle': 'Смета стоимости лечения',
  'estimate.create.cancel': 'Отмена',
  'estimate.create.confirm': 'Создать',
  'estimate.create.creating': 'Создание…',
  'estimate.fields.documentLocale': 'Язык документа',
  'estimate.fields.title': 'Название',
  'estimate.fields.planningDate': 'Дата расчёта цены',
  'estimate.fields.validThrough': 'Действует до',
  'estimate.fields.plannedStart': 'Плановое начало',
  'estimate.fields.plannedEnd': 'Плановое окончание',
  'estimate.fields.case': 'Случай',
  'estimate.fields.noCase': 'Без случая',
  'estimate.fields.assumptions': 'Допущения',

  'estimate.validation.title': 'Нужно название.',
  'estimate.validation.planningDate': 'Для выбора нового тарифа нужна дата расчёта цены.',
  'estimate.validation.source': 'Выберите датированный прейскурант и филиал для этой услуги.',
  'estimate.validation.validThrough': 'Нужна дата действия.',
  'estimate.validation.plannedRange': 'Плановое окончание не может быть раньше начала.',
  'estimate.validation.customTitleBlank': 'Произвольному разделу нужно название.',
  'estimate.validation.customTitleDuplicate': 'Два раздела не могут называться одинаково.',
  'estimate.validation.templateDuplicate': 'Каждый шаблон можно использовать один раз.',
  'estimate.validation.sectionLimit': 'Не более 20 разделов.',
  'estimate.validation.lineLimit': 'Не более 200 строк.',
  'estimate.validation.quantity': 'Количество должно быть от {min} до {max}.',
  'estimate.validation.quantityShort': 'Количество {min}–{max}',
  'estimate.validation.amount': 'Нужна цена.',
  'estimate.validation.overrideReason': 'Для изменённой цены нужна причина.',
  'estimate.validation.emptySection': 'В разделе «{name}» нет строк.',
  'estimate.validation.emptySections': 'Перед выпуском в каждом разделе должна быть хотя бы одна строка.',
  'estimate.validation.limits': 'Разделов: {sections} из 20 · Строк: {lines} из 200',
  'estimate.validation.noLines': 'Выберите хотя бы одну строку перед выпуском.',

  'estimate.section.untitled': 'Раздел без названия',
  'estimate.section.subtotal': 'Подытог {amount}',

  'estimate.totals.label': 'Итоги',
  'estimate.totals.clinic': 'Услуги клиники',
  'estimate.totals.external': 'Внешние расходы',
  'estimate.totals.grand': 'Общий итог',
  'estimate.totals.serverNote': 'По последнему сохранению на сервере.',
  'estimate.totals.localNote': 'Изменённые суммы будут подтверждены при сохранении черновика.',
  'estimate.totals.pending': 'Ожидает сохранения',
  'estimate.grid.label': 'Строки сметы',
  'estimate.grid.column.name': 'Позиция',
  'estimate.grid.column.quantity': 'Количество',
  'estimate.grid.column.unit': 'Единица',
  'estimate.grid.column.price': 'Цена за единицу',
  'estimate.grid.column.total': 'Итого',
  'estimate.grid.empty': 'Строк пока нет',
  'estimate.grid.emptyDetail':
    'Выберите услуги и внешние расходы на панели; каждая позиция попадает в группу своего каталога.',

  'estimate.conflict.title': 'Смета изменилась на сервере',
  'estimate.conflict.description': 'Кто-то сохранил эту смету после того, как вы её открыли.',
  'estimate.conflict.descriptionRevision': 'На сервере редакция {revision}; ваши правки сделаны поверх более старой.',
  'estimate.conflict.keepEditing': 'Продолжить редактирование',
  'estimate.conflict.reload': 'Отбросить мои изменения и перезагрузить',
  'estimate.conflict.reapply': 'Применить мои изменения к последней редакции',
  'estimate.conflict.reapplying': 'Применение…',
  'estimate.conflict.loading': 'Сравнение с сервером…',
  'estimate.conflict.loadFailed': 'Не удалось загрузить серверную редакцию.',
  'estimate.conflict.summaryLabel': 'Что отличается',
  'estimate.conflict.headerChanged': 'Изменённых полей шапки: {count}',
  'estimate.conflict.sectionsOnlyLocal': 'Разделов только в моём черновике: {count}',
  'estimate.conflict.sectionsOnlyServer': 'Разделов только на сервере: {count}',
  'estimate.conflict.linesOnlyLocal': 'Строк только в моём черновике: {count}',
  'estimate.conflict.linesOnlyServer': 'Строк только на сервере: {count}',
  'estimate.conflict.linesChanged': 'Строк, изменённых с обеих сторон: {count}',
  'estimate.conflict.noDifferences': 'Содержимое не отличается.',
  'estimate.conflict.reloadTitle': 'Отбросить ваши изменения?',
  'estimate.conflict.reloadDescription': 'Несохранённые правки будут заменены серверной редакцией.',
  'estimate.conflict.reloadConfirm': 'Отбросить и перезагрузить',

  'estimate.issue.title': 'Выпустить смету',
  'estimate.issue.description': 'Выпуск замораживает содержимое, присваивает номер и формирует PDF.',
  'estimate.issue.patient': 'Пациент',
  'estimate.issue.missing': 'Не указано',
  'estimate.issue.structure': 'Структура',
  'estimate.issue.structureValue': 'Разделов: {sections} · Строк: {lines}',
  'estimate.issue.blocked': 'Исправьте перед выпуском',
  'estimate.issue.cancel': 'Отмена',
  'estimate.issue.confirm': 'Выпустить и сформировать PDF',
  'estimate.issue.issuing': 'Выпуск…',
  'estimate.disclaimer': 'Это смета, а не счёт. Внешние расходы ориентировочны и оплачиваются третьим лицам.',

  'estimate.pdf.title': 'Документы PDF',
  'estimate.pdf.rendering': 'Формирование PDF…',
  'estimate.pdf.retry': 'Повторить PDF',
  'estimate.pdf.loadingArtifacts': 'Загрузка документов…',
  'estimate.pdf.artifactsFailed': 'Не удалось загрузить документы.',
  'estimate.pdf.none': 'PDF ещё не сформирован.',
  'estimate.pdf.renderer': 'Рендерер {version} · {hash}',
  'estimate.pdf.download': 'Скачать',
  'estimate.pdf.view': 'Открыть',
  'estimate.pdf.viewNamed': 'Открыть PDF: {language}',
  'estimate.pdf.downloadFailed': 'Не удалось скачать PDF.',
  'estimate.pdf.generate': 'Сформировать PDF',
  'estimate.pdf.forbidden': 'Вашей учётной записи не разрешено формировать этот PDF.',
  'estimate.pdf.unavailable': 'Для языка документа не привязана печатная форма.',
  'estimate.pdf.conflict': 'PDF по этому запросу уже был сформирован.',
  'estimate.pdf.failed': 'Не удалось сформировать PDF.',

  'estimate.send.open': 'Отправить пациенту',
  'estimate.send.needsPdf': 'Сначала сформируйте PDF.',
  'estimate.send.title': 'Отправить пациенту',
  'estimate.send.description': 'Пациент получит ссылку на PDF; срок действия ссылки ограничен.',
  'estimate.send.artifact': 'Документ',
  'estimate.send.artifactOption': '{locale} · {time}',
  'estimate.send.expiry': 'Ссылка действует',
  'estimate.send.preview': 'Предпросмотр сообщения',
  'estimate.send.previewBody':
    'Уважаемый пациент, ваша смета стоимости лечения «{title}» {number} готова. Смета действует до {validThrough}. Ссылка на документ действует {expiry}.',
  'estimate.send.cancel': 'Отмена',
  'estimate.send.confirm': 'Отправить',
  'estimate.send.sending': 'Отправка…',
  'estimate.send.done': 'Закрыть',
  'estimate.send.result': 'Доставка: {state}',

  'estimate.delivery.title': 'Отправки',
  'estimate.delivery.loading': 'Загрузка отправок…',
  'estimate.delivery.loadFailed': 'Не удалось загрузить отправки.',
  'estimate.delivery.none': 'Ещё не отправлялась.',
  'estimate.delivery.column.channel': 'Канал',
  'estimate.delivery.column.artifact': 'Документ',
  'estimate.delivery.column.state': 'Состояние',
  'estimate.delivery.column.times': 'Хронология',
  'estimate.delivery.column.link': 'Ссылка',
  'estimate.delivery.column.actions': 'Действия',
  'estimate.delivery.createdAt': 'Отправлена {time}',
  'estimate.delivery.expiresAt': 'Истекает {time}',
  'estimate.delivery.revokedAt': 'Отозвана {time}',
  'estimate.delivery.linkActive': 'Ссылка действует',
  'estimate.delivery.linkExpired': 'Ссылка истекла',
  'estimate.delivery.linkRevoked': 'Ссылка отозвана',
  'estimate.delivery.downloads': 'Скачиваний: {count}',
  'estimate.delivery.firstAccess': 'Впервые открыта {time}',
  'estimate.delivery.lastAccess': 'Последний раз открыта {time}',
  'estimate.delivery.revoke': 'Отозвать ссылку',
  'estimate.delivery.revokeTitle': 'Отозвать эту ссылку?',
  'estimate.delivery.revokeDescription':
    'Пациент больше не сможет открыть документ по ней. Дать ссылку снова можно только новой отправкой.',
  'estimate.delivery.revokeCancel': 'Оставить ссылку',
  'estimate.delivery.revokeConfirm': 'Отозвать',
  'estimate.delivery.revoking': 'Отзыв…',

  'estimate.revision.open': 'Редактировать',
  'estimate.revision.title': 'Редактировать эту смету?',
  'estimate.revision.description':
    'Редактируемая копия {number} (редакция {revision}) будет создана как новый черновик; этот документ остаётся выпущенным.',
  'estimate.revision.cancel': 'Отмена',
  'estimate.revision.confirm': 'Создать редактируемую копию',
  'estimate.revision.creating': 'Создание…',

  'estimate.delete.open': 'Удалить черновик',
  'estimate.delete.title': 'Удалить этот черновик?',
  'estimate.delete.description':
    'Черновик {name} и всё, что в него подобрано, будут удалены безвозвратно. Выпущенные документы это не затрагивает.',
  'estimate.delete.cancel': 'Оставить черновик',
  'estimate.delete.confirm': 'Удалить черновик',
  'estimate.delete.deleting': 'Удаление…',

  'estimate.revisions.column.status': 'Статус',
  'estimate.revisions.column.number': 'Номер',
  'estimate.revisions.column.when': 'Выпущена / обновлена',
  'estimate.revisions.column.total': 'Итого',
  'estimate.revisions.open': 'Открыть редакцию {revision}',
  'estimate.revisions.reading': 'Редакция {revision}, открыта сейчас',
  'estimate.revisions.loadFailed': 'Не удалось загрузить историю редакций.',

  'estimate.detail.loading': 'Загрузка сметы…',
  'estimate.detail.notFound': 'У этого пациента нет такой сметы.',
  'estimate.detail.forbidden': 'Вашей учётной записи не разрешено читать эту смету.',
  'estimate.detail.loadFailed': 'Не удалось загрузить смету.',
  'estimate.detail.readOnlyDraft': 'Этот черновик доступен вашей учётной записи только для чтения.',
  'estimate.detail.planned': 'Плановый период',
  'estimate.detail.issuedAt': 'Выпущена',
  'estimate.detail.updatedAt': 'Обновлена',
  'estimate.detail.factsLabel': 'Реквизиты документа',
  'estimate.detail.overrideNote': 'Цена изменена: {reason}',

  'estimate.builder.untitled': 'Смета без названия',
  'estimate.builder.backToList': 'Все сметы',
  'estimate.builder.updatedAt': 'Обновлена {time}',
  'estimate.builder.actionsLabel': 'Действия со сметой',
  'estimate.builder.saving': 'Сохранение…',
  'estimate.builder.unsaved': 'Есть несохранённые изменения',
  'estimate.builder.saved': 'Сохранено',
  'estimate.builder.detailsLabel': 'Реквизиты сметы',
  'estimate.builder.pick': 'Добавить позиции',
  'estimate.builder.save': 'Сохранить',
  'estimate.builder.issue': 'Выпустить и сформировать PDF',
  'estimate.builder.sectionLimit': 'Разделов не более: {limit}',
  'estimate.builder.lineLimit': 'Строк не более: {limit}',
  'estimate.builder.sectionLimitPick': 'Для {name} нужен новый раздел {section}, а в смете уже {limit} разделов.',
  'estimate.builder.alreadyPresent': '{name} уже есть в разделе {section}.',
  'estimate.builder.added': '{name} — добавлено в раздел {section}.',
  'estimate.builder.refreshUnavailable': '{name} больше нет в справочнике; строка сохраняет свой снимок.',
  'estimate.builder.refreshed': '{name} — обновлено из справочника.',

  'estimate.line.priceLocked': 'Цена клиники из прайс-листа',
  'estimate.line.overrideReason': 'Причина изменения цены {amount}',
  'estimate.line.note': 'Примечание',
  'estimate.line.noteLabel': 'Примечание к {name}',
  'estimate.line.refresh': 'Обновить {name} из справочника',
  'estimate.line.refreshHint': 'Взять текущие цену и название',
  'estimate.line.remove': 'Удалить {name} из раздела {section}',
  'estimate.line.quantityLabel': 'Количество: {name} ({unit})',
  'estimate.line.decrease': 'Уменьшить {name}',
  'estimate.line.increase': 'Увеличить {name}',
  'estimate.line.unitPrice': 'Цена за единицу: {name}',

  'estimate.remove.lineTitle': 'Удалить эту строку?',
  'estimate.remove.lineDescription':
    'У строки «{name}» есть примечание или изменённая цена; при удалении они пропадут.',
  'estimate.remove.cancel': 'Оставить',
  'estimate.remove.confirm': 'Удалить',
  'estimate.refresh.title': 'Обновить {name}?',
  'estimate.refresh.description': 'Справочник изменился с момента добавления строки.',
  'estimate.refresh.amount': 'Цена: {from} → {to}',
  'estimate.refresh.display': 'Название: {from} → {to}',
  'estimate.refresh.cancel': 'Оставить как есть',
  'estimate.refresh.confirm': 'Обновить',

  'estimate.picker.title': 'Услуги и внешние расходы',
  'estimate.picker.priceList': 'Прейскурант',
  'estimate.picker.choosePriceList': 'Выберите прейскурант',
  'estimate.picker.branch': 'Филиал',
  'estimate.picker.chooseBranch': 'Выберите филиал',
  'estimate.picker.selectionRequired': 'Выберите прейскурант и филиал.',
  'estimate.picker.selectionLoading': 'Загрузка прейскурантов и филиалов.',
  'estimate.picker.selectionFailed': 'Не удалось загрузить прейскуранты или филиалы.',
  'estimate.picker.datedForbidden': 'У вас нет доступа к прейскурантам.',
  'estimate.picker.resolving': 'Проверка цены на дату планирования.',
  'estimate.picker.resolveFailed': 'Не удалось определить цену для выбранных услуги, филиала и даты планирования. Пункт не добавлен.',
  'estimate.picker.currencyMismatch': 'Определение валюты источника отличается от валюты сметы.',
  'estimate.picker.baseTariff': 'Базовый тариф: {amount}',
  'estimate.picker.catalogueTab': 'Справочник',
  'estimate.picker.searchPlaceholder': 'Поиск по коду или названию',
  'estimate.picker.hint': 'Выбранная позиция попадает в группу своего каталога.',
  'estimate.picker.shortlistMissing': '{name} — нет в прайс-листе.',
  'estimate.picker.clinicHint': 'Услуги клиники из прайс-листа',
  'estimate.picker.externalHint': 'Внешние расходы из справочника',
  'estimate.picker.noMatches': 'Ничего не найдено.',
  'estimate.picker.clinicLeafMeta': '{unit}',
  'estimate.picker.externalLeafMeta': '{path} · {unit}',
  'estimate.picker.externalLoading': 'Загрузка справочника внешних расходов…',
  'estimate.picker.externalFailed': 'Не удалось загрузить справочник внешних расходов.',
  'estimate.picker.externalEmpty': 'Справочник внешних расходов пуст.',
  'estimate.picker.lineLimit': 'В смете уже 200 строк.',
  'estimate.unsavedIntent': 'смета с несохранёнными изменениями',

  'externalCosts.title': 'Внешние расходы',
  'externalCosts.subtitle': 'Сторонние расходы, которые смета может указать рядом с услугами клиники',
  'externalCosts.forbidden': 'Справочник внешних расходов недоступен вашей учётной записи.',
  'externalCosts.loading': 'Загрузка справочника…',
  'externalCosts.loadFailed': 'Не удалось загрузить справочник.',
  'externalCosts.tableLabel': 'Каталог внешних расходов',
  'externalCosts.column.name': 'Название',
  'externalCosts.column.group': 'Группа',
  'externalCosts.column.unit': 'Единица',
  'externalCosts.column.amount': 'Цена по умолчанию',
  'externalCosts.column.status': 'Статус',
  'externalCosts.actions': 'Действия',
  'externalCosts.editNamed': 'Изменить {name}',
  'externalCosts.openNamed': 'Открыть {name}',
  'externalCosts.openGroupNamed': 'Открыть группу {name}',
  'externalCosts.moveSelected': 'Перенести выделенные ({count})',
  'externalCosts.moveSelectedTitle': 'Перенести в другую группу',
  'externalCosts.moveSelectedDescription':
    'Записи каталога ({count}) встанут в конец выбранной группы в том порядке, в каком они идут в дереве.',
  'externalCosts.moveSelectedTarget': 'Куда перенести',
  'externalCosts.moveSelectedHint': 'Показаны только группы, способные вместить всё выделение.',
  'externalCosts.moveSelectedConfirm': 'Перенести записи ({count})',
  'externalCosts.moveSelectedCancel': 'Оставить выделение',
  'externalCosts.movedCount': 'Записей перенесено: {count}.',
  'externalCosts.movedBefore': 'До этого перенесено записей: {count}.',
  'externalCosts.empty': 'Внешних расходов нет',
  'externalCosts.emptyDetail': 'Пока ничего не добавлено.',
  'externalCosts.emptyDetailManage': 'Добавьте расход — группа объединяет несколько.',
  'externalCosts.noMatches': 'Ничего не найдено.',
  'externalCosts.noMatchesDetail': 'Снимите фильтр, чтобы увидеть больше каталога.',
  'externalCosts.pathStep': '{parent} / {child}',
  'externalCosts.archived': 'В архиве',
  'externalCosts.archivedByParent': 'В архивной группе',
  'externalCosts.status.active': 'Активен',
  'externalCosts.saved': 'Сохранено.',
  'externalCosts.unsavedIntent': 'узел внешних расходов с несохранёнными изменениями',
  'externalCosts.kind.group': 'Группа',
  'externalCosts.kind.item': 'Позиция',
  'externalCosts.groups.open': 'Группы',
  'externalCosts.groups.title': 'Группы',
  'externalCosts.tree.search': 'Поиск по каталогу',
  'externalCosts.tree.root': 'Весь каталог',
  'externalCosts.tree.showAll': 'Всё',
  'externalCosts.tree.showGroups': 'Только группы',
  'externalCosts.tree.showItems': 'Только позиции',
  'externalCosts.tree.empty': 'Групп и позиций пока нет.',
  'externalCosts.tree.levelEmpty': 'Здесь пока ничего не размещено.',
  'externalCosts.tree.levelItemsOnly': 'Здесь только позиции, а показаны только группы.',
  'externalCosts.tree.unfold': 'Показать всё',
  'externalCosts.tree.noMatches': 'В каталоге ничего не найдено.',
  'externalCosts.tree.scopeChip': 'В группе {name}',
  'externalCosts.tree.scopeClear': 'Показать весь каталог',
  'externalCosts.tree.menu': 'Действия для {name}',
  'externalCosts.tree.open': 'Открыть',
  'externalCosts.tree.rename': 'Переименовать',
  'externalCosts.tree.addGroup': 'Добавить группу сюда',
  'externalCosts.tree.addItem': 'Добавить позицию сюда',
  'externalCosts.tree.moveEarlier': 'Переместить выше',
  'externalCosts.tree.moveLater': 'Переместить ниже',
  'externalCosts.tree.moveToTop': 'Переместить на верхний уровень',
  'externalCosts.tree.stale': 'Каталог тем временем изменился и был перезагружен. Попробуйте ещё раз.',
  'externalCosts.create.under': 'В группе {name}',
  'externalCosts.create.kind': 'Что добавить',
  'externalCosts.create.groupHint': 'Заголовок, объединяющий позиции',
  'externalCosts.create.itemHint': 'Расход с ценой и единицей',
  'externalCosts.create.submit': 'Создать',
  'externalCosts.create.creating': 'Создание…',
  'externalCosts.detail.archive': 'В архив',
  'externalCosts.detail.restore': 'Восстановить',
  'externalCosts.detail.noAmount': 'Цена по умолчанию не задана',
  'externalCosts.editor.newGroup': 'Новая группа',
  'externalCosts.editor.newItem': 'Новая позиция',
  'externalCosts.editor.name': 'Название',
  'externalCosts.editor.description': 'Описание',
  'externalCosts.editor.unit': 'Единица',
  'externalCosts.editor.unitNone': 'Без единицы',
  'externalCosts.editor.amount': 'Цена по умолчанию, {currency}',
  'externalCosts.editor.amountUnknown': 'Цена по умолчанию',
  'externalCosts.error.currencyUnavailable': 'Валюта финансового профиля недоступна. Сохранение записей каталога невозможно.',
  'externalCosts.error.currencyMismatch': 'Определение валюты этой цены отличается от текущего финансового профиля. Создайте новый пункт для текущей валюты.',
  'externalCosts.editor.group': 'Группа',
  'externalCosts.editor.groupHint': 'Справочник хранит один уровень групп.',
  'externalCosts.editor.rootParent': 'Верхний уровень',
  'externalCosts.editor.save': 'Сохранить',
  'externalCosts.editor.saving': 'Сохранение…',
  'externalCosts.editor.gone': 'Этого узла больше нет в справочнике.',
  'externalCosts.editor.conflict':
    'Справочник изменился после открытия формы. Перезагрузите его — введённое сохранится — и сохраните снова.',
  'externalCosts.editor.reload': 'Перезагрузить справочник',
  'externalCosts.editor.reloading': 'Перезагрузка…',
  'externalCosts.editor.discard': 'Отбросить мои изменения',
  'externalCosts.validation.name': 'Нужно название.',
  'externalCosts.validation.unit': 'Для позиции нужна единица.',
  'externalCosts.validation.amount': 'Введите неотрицательную цену с точным числом десятичных знаков валюты.',
  'externalCosts.error.codeConflict': 'Не удалось подобрать внутренний код записи. Повторите попытку.',
  'externalCosts.error.cycle': 'Группу нельзя переместить внутрь самой себя.',
  'externalCosts.error.parentUnavailable': 'Выбранный родитель удалён или в архиве.',
  'externalCosts.error.depthExceeded': 'Дерево допускает не более шести уровней.',
  'externalCosts.error.forbidden': 'Вашей учётной записи не разрешено менять справочник.',
  'externalCosts.error.invalid': 'Сервер отклонил узел в отправленном виде.',
  'externalCosts.error.failed': 'Не удалось изменить справочник.',
  'externalCosts.error.conflict': 'Справочник отклонил изменение.',
  'externalCosts.archive.title': 'Отправить {name} в архив?',
  'externalCosts.archive.groupDescription':
    'Группа перестанет предлагаться новым строкам смет, как и вложенные в неё узлы, всего: {count}. Существующие строки сохраняют свои снимки.',
  'externalCosts.archive.itemDescription':
    'Позиция перестанет предлагаться новым строкам смет. Существующие строки сохраняют свои снимки.',
  'externalCosts.archive.cancel': 'Оставить',
  'externalCosts.archive.confirm': 'В архив',
  'externalCosts.archive.archiving': 'Архивирование…',
}
